import * as React from 'react';
import { mergeProps } from '../merge-props/index.js';
export function evaluateRenderProp(render, props, state) {
  return typeof render === 'function' ? render(props, state) : /*#__PURE__*/React.cloneElement(render, {
    ...mergeProps(props, render.props),
    ref: props.ref
  });
}